import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const SliderWarning = () => {
  return (
    <Box display={'inline-flex'} width={'100%'} justifyContent={'center'} alignItems={'center'} pt={2} pb={2}>
      <Font variant={'body2'} style={{ paddingRight: 6 }} color={'textSecondary'}>
        <Text tId={'SLIDE_TO_SEE_ALL_VALUES'} />
      </Font>
      <Font variant={'body2'} color={'textSecondary'}>
        <i className="material-icons-outlined">swipe</i>
      </Font>
    </Box>
  );
};
